/*
====================================================================
Module: naviplus-cart-beacon
役割: AJAX カート加算成功時に NaviPlus behaviorType=2 を送信
依存: window._sna_dam（beaver.js / naviplus_common）
利用: addCart.js 成功レスポンス / ajax_cart_handle_item
====================================================================
*/

/** @type {ReturnType<typeof setTimeout>|null} */
let debounceTimer = null;

/** @type {{pushes?: Array<[string, unknown]>}|null} */
let pendingPayload = null;

/**
 * beaver.js ACCEPT_TIME(100ms) より長くする.
 * scan の items は PAGE_TRANSITION しない限り concat され続けるため、
 * pageTransition → member 再 push → 待機 → 最新カート push の順にする.
 */
const AFTER_RESET_MS = 150;

/** pageTransition で消える会員系キー（cart / customer 両ストリーム） */
const MEMBER_KEYS = new Set(['userCode', 'status', 'email']);

/**
 * @param {{pushes?: Array<[string, unknown]>}|null|undefined} payload
 * @returns {Array<[string, unknown]>}
 */
function getPushes(payload) {
  if (!payload || !Array.isArray(payload.pushes)) {
    return [];
  }
  return payload.pushes.filter((entry) => Array.isArray(entry) && entry.length >= 2);
}

/**
 * beaver scan の items をリセットする（公式 pageTransition）。
 * PAGE_TRANSITION は userCode / status も消すため、直後に seedMemberPushes すること.
 */
function resetNaviPlusItems() {
  window._sna_dam = window._sna_dam || [];
  if (typeof window._sna_dam.pageTransition === 'function') {
    window._sna_dam.pageTransition();
    return;
  }
  window._sna_dam.push(['PAGE_TRANSITION', undefined]);
}

/**
 * pageTransition 直後に会員識別を戻す.
 *
 * @param {{pushes?: Array<[string, unknown]>}|null|undefined} payload
 * @returns {void}
 */
function seedMemberPushes(payload) {
  window._sna_dam = window._sna_dam || [];
  getPushes(payload).forEach((entry) => {
    if (MEMBER_KEYS.has(String(entry[0]))) {
      window._sna_dam.push(entry);
    }
  });
}

/**
 * customer ストリームを即座に flush する（2回目 +/- で customer beacon が落ちる対策）.
 * CUSTOMER_END は RESET ではなく reception interrupt のみ.
 *
 * @param {{pushes?: Array<[string, unknown]>}|null|undefined} payload
 * @returns {void}
 */
function forceCustomerBeacon(payload) {
  seedMemberPushes(payload);
  window._sna_dam = window._sna_dam || [];
  window._sna_dam.push(['CUSTOMER_END', undefined]);
}

/**
 * 最新カート payload を _sna_dam へ push する（member 含む全 pushes）.
 *
 * @param {{pushes?: Array<[string, unknown]>}|null|undefined} payload
 * @returns {void}
 */
function flushNaviPlusCartBeacon(payload) {
  const pushes = getPushes(payload);
  if (pushes.length === 0) {
    return;
  }

  window._sna_dam = window._sna_dam || [];
  pushes.forEach((entry) => {
    window._sna_dam.push(entry);
  });
}

/**
 * NaviPlus cart beacon payload を _sna_dam へ push する.
 *
 * @param {{pushes?: Array<[string, unknown]>}|null|undefined} payload
 * @returns {void}
 */
export function pushNaviPlusCartBeacon(payload) {
  if (getPushes(payload).length === 0) {
    return;
  }

  pendingPayload = payload;

  if (debounceTimer !== null) {
    window.clearTimeout(debounceTimer);
  }

  // 1) items 破棄  2) userCode/status を即戻す  3) 最新カート push  4) customer を強制 flush
  resetNaviPlusItems();
  seedMemberPushes(pendingPayload);
  debounceTimer = window.setTimeout(() => {
    debounceTimer = null;
    const latest = pendingPayload;
    pendingPayload = null;
    flushNaviPlusCartBeacon(latest);
    forceCustomerBeacon(latest);
  }, AFTER_RESET_MS);
}

window.EC = window.EC || {};
window.EC.pushNaviPlusCartBeacon = pushNaviPlusCartBeacon;
